var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "global-layout",
    [
      _c("contextmenu", {
        attrs: { itemList: _vm.menuItemList, visible: _vm.menuVisible },
        on: {
          "update:visible": function($event) {
            _vm.menuVisible = $event
          },
          select: _vm.onMenuSelect
        }
      }),
      _vm._v(" "),
      _vm.multipage
        ? _c(
            "a-tabs",
            {
              staticStyle: { "margin-top": "-8px", "margin-bottom": "8px" },
              attrs: {
                "active-key": _vm.activePage,
                "hide-add": true,
                type: "editable-card"
              },
              on: { change: _vm.changePage, edit: _vm.editPage },
              nativeOn: {
                contextmenu: function($event) {
                  return function(e) {
                    return _vm.onContextmenu(e)
                  }.apply(null, arguments)
                }
              }
            },
            _vm._l(_vm.pageList, function(page) {
              return _c(
                "a-tab-pane",
                { key: page.fullPath, attrs: { id: page.fullPath } },
                [
                  _c(
                    "span",
                    {
                      attrs: { slot: "tab", pagekey: page.fullPath },
                      slot: "tab"
                    },
                    [_vm._v(_vm._s(page.name))]
                  )
                ]
              )
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "page-toggle" } },
        [
          _vm.multipage
            ? _c("keep-alive", [_c("router-view")], 1)
            : _c("router-view")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b3b3463", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b3b3463","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/MenuView.vue
// module id = null
// module chunks = 